



















































































































































































































































































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";
import TooltipModule from "@/store/tooltip";
import UserModel from "@/store/user";
import StripeApi from "@/services/StripeApi";
import { CreateCard, CreateCustomer, CreateSubscription, Plan } from "@/api/lab-base-api-client";
import AuthModule from "@/store/auth";
import CTooltip from "@/components/CTooltip.vue";
import { loadStripe, StripeCardNumberElement } from "@stripe/stripe-js";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class URegisterPlan extends CheckUserLogin {
  // customer form
  private customer: CreateCustomer = {
    email: "",
    name: "",
    uuid: "",
  };

  // card form
  private card: CreateCard | { cusId: string; number: null; exp_month: null; exp_year: null; cvc: null } = {
    cusId: "",
    number: null,
    // eslint-disable-next-line @typescript-eslint/camelcase
    exp_month: null,
    // eslint-disable-next-line @typescript-eslint/camelcase
    exp_year: null,
    cvc: null,
  };

  // coupon form
  private subscription: CreateSubscription = {
    cusId: "",
    planId: "",
    promoCode: undefined,
    userUuid: "",
  };

  // plan form
  private plan: Plan | null = null;

  // plans
  private plans: Plan[] = [];

  // 送信中のLiner
  private isProgressLiner = false;

  // カード情報入力stepのエラーメッセージ
  private isCardErrMsg = false;

  // stepper tab 初期値
  private stepPage = 1;

  // customer id
  private cusId = "";

  // card バリデーション
  private cardInvalid = true;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private get paymentEmail() {
    return UserModel.paymentEmail;
  }

  private get STRIPE_PUBLISHABLE_KEY() {
    return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
  }

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private async mounted() {
    if (this.me && this.me.paidFlag) {
      this.$router.push({ name: "UDashboard" });
    } else {
      await this.fetchPlan();
      this.stripe();
    }
  }

  // 次へ進む
  private next(index: number) {
    this.stepPage = index + 1;
  }

  // step1 プラン一覧取得
  private async fetchPlan() {
    const plansRes = await StripeApi.instance.allGetPlan();
    // nicknameが存在するplan
    this.plans = plansRes.data.data.filter((plans: { nickname: {} }) => plans.nickname);
  }

  // stripe
  private async stripe() {
    if (!this.STRIPE_PUBLISHABLE_KEY) {
      return;
    }
    const stripe = await loadStripe(this.STRIPE_PUBLISHABLE_KEY);

    if (!stripe) {
      logger.frontError("failed load stripe");
      throw new Error("Failed load stripe");
    }
    // カード入力情報step
    const elements = stripe?.elements();

    // カード入力inputのスタイル
    const elementStyles = {
      base: {
        color: "#000000",
        fontWeight: "bold",
        fontFamily: "Yu Gothic, YuGothic",
        fontSize: "16px",
        lineHeight: "2",

        "::placeholder": {
          color: "#c0c0c0",
        },

        ":focus::placeholder": {
          color: "#c0c0c0",
        },
      },
      invalid: {
        color: "red",
        ":focus": {
          color: "#E83A3B",
        },
        "::placeholder": {
          color: "#E83A3B",
        },
      },
      complete: {
        backgroundColor: "#ffffff",
      },
    };

    // クラスの設定
    const elementClasses = {
      focus: "focus",
      empty: "empty",
      invalid: "invalid",
      complete: "complete",
    };

    const cardNumber = elements?.create("cardNumber", {
      style: elementStyles,
      classes: elementClasses,
    });
    // eslint-disable-next-line no-unused-expressions
    cardNumber?.mount("#cardNumber");

    const cardExpiry = elements?.create("cardExpiry", {
      style: elementStyles,
      classes: elementClasses,
    });
    // eslint-disable-next-line no-unused-expressions
    cardExpiry?.mount("#cardExpiry");

    const cardCvc = elements?.create("cardCvc", {
      style: elementStyles,
      classes: elementClasses,
    });

    // eslint-disable-next-line no-unused-expressions
    cardCvc?.mount("#cardCvc");

    // 入力に変更があった場合に実行
    // eslint-disable-next-line no-unused-expressions
    cardNumber?.on("change", ({ error }) => {
      const displayError = document.getElementById("cardNumberErrors");
      if (displayError) {
        if (error) {
          displayError.textContent = error.message;
          this.cardInvalid = true;
        } else {
          displayError.textContent = "";
          this.cardInvalid = false;
          this.isCardErrMsg = false;
        }
      }
    });
    // eslint-disable-next-line no-unused-expressions
    cardExpiry?.on("change", ({ error }) => {
      const displayError = document.getElementById("cardExpiryErrors");
      if (displayError) {
        if (error) {
          displayError.textContent = error.message;
          this.cardInvalid = true;
        } else {
          displayError.textContent = "";
          this.cardInvalid = false;
          this.isCardErrMsg = false;
        }
      }
    });
    // eslint-disable-next-line no-unused-expressions
    cardCvc?.on("change", ({ error }) => {
      const displayError = document.getElementById("cardCvcErrors");
      if (displayError) {
        if (error) {
          displayError.textContent = error.message;
          this.cardInvalid = true;
        } else {
          displayError.textContent = "";
          this.cardInvalid = false;
          this.isCardErrMsg = false;
        }
      }
    });

    const submit = document.getElementById("submitBtn");

    if (submit) {
      const cardElement = elements.getElement("cardNumber") as StripeCardNumberElement;
      if (this.me?.cusId) {
        this.cusId = this.me.cusId;
      }
      submit.addEventListener("click", async () => {
        this.isProgressLiner = true;
        stripe
          .createPaymentMethod({
            type: "card",
            card: cardElement,
            // eslint-disable-next-line @typescript-eslint/camelcase
            billing_details: {
              name: this.me?.userDetail.fullName,
            },
          })
          .then(async result => {
            await this.registerCustomer();
            return result;
          })
          .then(async result => {
            if (result.error) {
              console.log("err", result.error);
            } else {
              const paymentMethodId = await result.paymentMethod.id;
              const { cusId } = this;
              try {
                await StripeApi.instance.postPaymentMethods({ cusId, paymentMethodId });
              } catch (error) {
                try {
                  await StripeApi.instance.postUpdatePaymentMethods({ cusId, paymentMethodId });
                } catch (err) {
                  if (err instanceof Error) {
                    logger.frontError(`${err.name}: ${err.message}`);
                    console.log(err);
                  }
                  TooltipModule.commitIsShow(true);
                  setTimeout(() => {
                    TooltipModule.commitIsShow(false);
                  }, 5000);
                  this.stepPage = 1;
                  this.isProgressLiner = false;
                  throw err;
                }
              }
            }
          })
          .then(() => {
            this.createSubscription();
          });
      });
    }
  }

  // 顧客情報の登録
  private async registerCustomer() {
    if (this.me?.uuid) {
      this.customer.uuid = this.me?.uuid;
    }
    try {
      // カスタマーが登録済の場合
      if (this.cusId) {
        const cusRes = await StripeApi.instance.updateCustomer({
          cusId: this.cusId,
          name: this.customer.name,
          email: this.customer.email,
        });
        this.cusId = cusRes.data.id;
        // カスタマーが未登録の場合
      } else {
        const cusRes = await StripeApi.instance.createCustomer(this.customer);
        this.cusId = cusRes.data.id;
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      this.stepPage = 1;
      this.isProgressLiner = false;

      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // subscription 登録
  private async createSubscription() {
    this.subscription.cusId = this.cusId;
    if (this.plan !== null) {
      this.subscription.planId = this.plan.id;
    }
    if (this.me?.uuid) {
      this.subscription.userUuid = this.me?.uuid;
    }
    // プロモーションコードが空文字の場合undefineを代入
    if (this.subscription.promoCode === "") {
      this.subscription.promoCode = undefined;
    }

    try {
      await StripeApi.instance.createSubscription(this.subscription);
      this.stepPage = 6;
    } catch (err) {
      logger.frontError(err);
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      this.stepPage = 1;
      this.isProgressLiner = false;

      if (err instanceof Error) {
        if (err instanceof Error) {
          logger.frontError(`${err.name}: ${err.message}`);
          console.log(err);
        }
      }
    }
  }

  // card情報入力が完了しているかチェックして、確認stepへ
  private toConfirm() {
    const number = document.getElementById("cardNumber");
    const expiry = document.getElementById("cardExpiry");
    const cvc = document.getElementById("cardCvc");
    if (number && expiry && cvc) {
      if (
        number.classList.contains("complete") &&
        expiry.classList.contains("complete") &&
        cvc.classList.contains("complete")
      ) {
        this.cardInvalid = false;
        this.isCardErrMsg = false;

        this.stepPage = 4;
      } else {
        this.isCardErrMsg = true;
      }
    }
  }
}
